import {getCookie, setCookie, existsCookie, deleteCookie} from './cookie';
import {getConsentCookie, setConsentCookie, existsConsentCookie, resaveConsentCookie} from './consent';
import {copyTcf2FromGlobalStorage} from './cmp2';
import {DIALOG_CLOSED, DIALOG_EXITED, DIALOG_FAILED, SID_COOKIE_NAME} from '../constants';
import {isSafari} from '../utils/sbrowser';
import {end} from './measurement';
import {setCookieToGlobalStorage} from './globalCookie';
import {checkNoOpenInterval} from '../utils/checks';
import {logger} from './logger';

const CONSENT = '$consent';
const SID = '$znacka';
const BACK_URL = '$backUrl';
const USER_TYPE = '$userType';
const DESTINATION_URL_HREF = 'https://www.seznam.cz/nastaveni-souhlasu/';
const DESTINATION_URL_HREF_DEV = 'https://consent.setting.dev.ko.seznam.cz/';
const FALLBACK_URL = 'https://o.seznam.cz/ochrana-udaju/personalizace-obsahu-a-reklamy/';
const FAILED_CONSENT = false;
const PREFIX_LENGTH = 3;
const SESSION_EXPIRACY = -1;
const REDIRECT_WHITELIST = [
  'kuchticka.cz',
  'www.kupi.cz',
  'www.sbazar.cz',
  'www.sauto.cz',
  'www.smoto.cz',
  'www.televizeseznam.cz',
  'www.volnamista.cz',
  'pocasi.seznam.cz',
  'tv.seznam.cz',
  'sdovolena.seznam.cz',
  'www.sreality.cz',
  'www.novinky.cz',
  'www.garaz.cz'
];

const makePrefix = string => string.substring(0, PREFIX_LENGTH);

const hashIt = (name, value) => makePrefix(name) + window.btoa(unescape(encodeURIComponent(value)));

const unhashIt = hash => decodeURIComponent(escape(window.atob(hash.substring(PREFIX_LENGTH))));

const findParamWithPrefix = (url, prefix) => Array.from(url.searchParams.keys()).find(key => makePrefix(key) === prefix);

const cutValueFromLocationUrl = paramName => {
  const url = new URL(location.href);
  const param = findParamWithPrefix(url, makePrefix(paramName));

  if (param) {
    url.searchParams.delete(param);

    history.pushState({}, '', url.href);
    return unhashIt(param);
  }
};

const redirect = (href, pairs) => {
  if (!href) {
    logger(1600, 'Cannot redirect, no consent setting page url defined');
    return;
  }

  const url = new URL(href);

  if (Array.isArray(pairs)) {
    pairs.forEach(([key, value]) => url.searchParams.set(hashIt(key, value), ''));
  }

  logger(1601, 'Redirect return to:', url.href);
  location.href = url.href;
};

const goBack = (backUrl, isConsentOk = true) => {
  deleteCookie(BACK_URL);
  deleteCookie(USER_TYPE);

  const returnPairs = [[SID, getCookie(SID_COOKIE_NAME)]];

  if (isConsentOk) {
    returnPairs.push([CONSENT, getConsentCookie()]);
  }

  redirect(backUrl, returnPairs);
};

export const initGoBackAndUser = () => {
  let userType = cutValueFromLocationUrl(USER_TYPE);
  let backUrl = cutValueFromLocationUrl(BACK_URL);

  if (backUrl) {
    setCookie(backUrl, BACK_URL, SESSION_EXPIRACY);
  } else if (existsCookie(BACK_URL)) {
    backUrl = getCookie(BACK_URL);
  }

  if (userType) {
    setCookie(userType, USER_TYPE, SESSION_EXPIRACY);
  } else if (existsCookie(USER_TYPE)) {
    userType = getCookie(USER_TYPE);
  }

  if (!userType || !backUrl) {
    location.href = FALLBACK_URL;
  }

  window.addEventListener(DIALOG_CLOSED, () => goBack(backUrl));
  window.addEventListener(DIALOG_EXITED, () => goBack(backUrl, FAILED_CONSENT));
  window.addEventListener(DIALOG_FAILED, () => goBack(backUrl, FAILED_CONSENT));

  return userType;
};

export const initRedirect = async (userType, isDev = false) => {
  /* Temporary for switching to CMP2 */
  const tcf2Copied = await copyTcf2FromGlobalStorage(userType);

  if (tcf2Copied) {
    // TCF2.0 successfully copied to local domain
    end();
    return;
  }
  /* end of temporary switching to CMP2 */

  const euconsent = cutValueFromLocationUrl(CONSENT);

  if (euconsent) {
    logger(1602, 'Got euconsent from redirect:', euconsent);
    setConsentCookie(euconsent);
    document.addEventListener('DOMContentLoaded', () => setCookieToGlobalStorage(euconsent, userType));
  } else if (existsConsentCookie()) {
    resaveConsentCookie();
  }
  //redirect to dialog
  if (checkNoOpenInterval() && (!existsCookie(SID_COOKIE_NAME) || !existsConsentCookie())) {
    logger(1004, 'Redirecting');
    end();
    redirect(isDev ? DESTINATION_URL_HREF_DEV : DESTINATION_URL_HREF, [[BACK_URL, location.href], [USER_TYPE, userType]]);
  } else {
    logger(1005, 'Redirect done');
    end();
  }
};

export const inRedirectWhitelist = REDIRECT_WHITELIST.includes(location.hostname);

export const shouldRedirect = () => isSafari && REDIRECT_WHITELIST.includes(location.hostname);
